import { Box } from '@mui/material';
import { RightMenuNavigation, Route } from 'app/enums';
import { RightSidebarContext } from 'app/providers';
import logo from 'assets/images/okletsplay_logo-text.png';
import React, { FC, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './Logo.styles';

export const Logo: FC = () => {
  const { classes } = useStyles();
  const { setActiveTab } = useContext(RightSidebarContext);

  const navigate = useNavigate();

  const onClickHandler = useCallback(() => {
    setActiveTab(RightMenuNavigation.Home);
    navigate(Route.Home);
  }, [navigate, setActiveTab]);

  return (
    <Box onClick={onClickHandler} className={classes.root}>
      <Box className={classes.logoContainer}>
        <img src={logo} alt="okletsplay" className={classes.logo} width="272" height="32" />
      </Box>
    </Box>
  );
};
